// extracted by mini-css-extract-plugin
export default {"icon":"ColorPalette_icon__pDlfy","margin":"ColorPalette_margin__WOI7-","label":"ColorPalette_label__FCvkM"};